export const Card = ({ title, icon, children, className = "" }) => (
    <div className={`rounded-2xl border border-gray-100 bg-white p-5 shadow-sm dark:border-navy-700 dark:bg-navy-800 ${className}`}>
        {title && (
            <h3 className="mb-4 flex items-center gap-2 text-base font-bold text-navy-700 dark:text-white">
                {icon && <span className="text-gray-600 dark:text-gray-300">{icon}</span>}
                {title}
            </h3>
        )}
        <div className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
            {children}
        </div>
    </div>
)

export const Row = ({ label, value, full = false }) => (
    <div className={full ? "sm:col-span-2" : ""}>
        <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{label}</p>
        <p className="break-words text-sm font-semibold text-navy-700 dark:text-white">{value ?? "—"}</p>
    </div>
)

const ACTION_COLORS = {
    green: "bg-aprobado hover:opacity-90 text-white",
    red: "bg-cancelado hover:opacity-90 text-white",
    orange: "bg-pendiente hover:opacity-90 text-white",
    navy: "bg-navy-700 hover:bg-navy-800 text-white",
}

export const ActionButton = ({ children, color = "navy", ...props }) => (
    <button
        className={`w-full rounded-lg px-4 py-2 text-sm font-semibold transition duration-200 ${ACTION_COLORS[color]}`}
        {...props}
    >
        {children}
    </button>
)
